import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LanguageContext } from "./Providers/LanguageContext";
import 'bootstrap/dist/css/bootstrap.min.css';
import UserWrapper from "./Providers/UserWrapper";
import SpeechWrapper from "./Providers/SpeechWrapper";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";
import Chatbox from "./View/Chatbox/Chatbox";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <LanguageContext>
      <UserWrapper>
        <SpeechWrapper>
        <Chatbox/>
          <App />
        </SpeechWrapper>
      </UserWrapper>
    </LanguageContext>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
